namespace Matrix.Data {
    export interface RowCustomizationRow {
        RowCode?: string;
        ApprovalQueueCode?: string;
        InsertApproval?: boolean;
        UpdateApproval?: boolean;
        DeleteApproval?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace RowCustomizationRow {
        export const idProperty = 'RowCode';
        export const nameProperty = 'RowCode';
        export const localTextPrefix = 'Data.RowCustomization';
        export const deletePermission = 'DataAdmin:RowCustomization';
        export const insertPermission = 'DataAdmin:RowCustomization';
        export const readPermission = 'Read:RowCustomization';
        export const updatePermission = 'DataAdmin:RowCustomization';

        export declare const enum Fields {
            RowCode = "RowCode",
            ApprovalQueueCode = "ApprovalQueueCode",
            InsertApproval = "InsertApproval",
            UpdateApproval = "UpdateApproval",
            DeleteApproval = "DeleteApproval",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
